const { LoginResult } = require('./constant');

function MobileNumberCaptureController($state, loginService, moveFocus) {
    this.$onInit = function() {
        this.loginService = loginService;
        this.moveFocus = moveFocus;
        this.numberInput = '';
        this.loading = false;
        this.$state = $state;

        // Move focus to input when view has loaded
        moveFocus('#mobileNumberCaptureForm-number');
    };
}

MobileNumberCaptureController.prototype.sendCode = function () {
    const self = this;
    this.mobileNumberCaptureForm.Number.$setValidity('server', true);

    if (!this.mobileNumberCaptureForm.$valid) {
        // don't submit to server if client side is not valid
        return;
    }
    this.loading = true;

    this.loginService.sendOTP(this.email, this.password, this.numberInput).then(
        function (response) {
            self.loading = false;
            if (response.LoginResult === LoginResult.REQUIRE_SMS_MFA) {
                self.$state.go('shop.authentication.verifyMobile', {
                    email: self.email,
                    password: self.password,
                    phone: self.numberInput,
                    phoneMasked: response.MaskedPhone
                });
            } else if (response.LoginResult === LoginResult.INVALID_PHONE) {
                self.serverErrorMessage = response.AuthenticationErrorMessage;
                self.mobileNumberCaptureForm.Number.$setValidity('server', false);
            } else if (response.LoginResult === LoginResult.TOO_MANY_MFA_ATTEMPTS) {
                self.$state.go('shop.authentication.error', { error: 'TooManyCodeGenerationAttempts' });
            } else {
                self.$state.go('shop.authentication.login');
            }
        }
    ).catch(function() {
        self.loading = false;
        self.$state.go('shop.authentication.login');
    });
};

function mobileNumberCaptureDirectiveFactory() {
    return {
        restrict: 'E',
        scope: {
            email: '@',
            password: '@'
        },
        controller: ['$state', 'LoginService', 'MoveFocus', MobileNumberCaptureController],
        controllerAs: 'ctrl',
        bindToController: true,
        template: require('./login-mobile-number-capture-template.html').trim()
    };
}

module.exports = {
    DirectiveController: MobileNumberCaptureController,
    directiveFactory: mobileNumberCaptureDirectiveFactory
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/login/login-mobile-number-capture-directive.js
 **/